// extracted by mini-css-extract-plugin
export default {"tcoButton":"_1cM9t3"};